<template>
  <div class="banner-container">
    <div v-for="(banner, index) in banners" :key="index" class="banner-item">
      <img :src="banner.img_link_url_mobile" :alt="`${banner.name}`" class="banner-img" @click="directive(banner.link_url)"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BannerMobile',
  props: {
    banners: Array,
    default: () => []
  },
  methods: {
    directive(link) {
      if (link && link != "-") window.open(link)
    }
  }
}
</script>

<style src="./css/bannerMobile.css" scoped></style>